import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

export const FindingHardToUse = ({
  selectedTimeLine = '',
  handCloseModal = () => {},
  handleChangePlanModal = () => {}
}) => {
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};

  return (
    <>
      <Typography>FindingHardToUse</Typography>
    </>
  );
};
